export const INPUT_TYPE = {
  INPUT_CLAIM_NUMBER: 'input_claim_number',
  LIST_DOC_TYPE: 'list_doc_type',
  INPUT_COMMENT: 'input_comment',
};

export const CORPO_IMAGINE_CODE = '23';
